import React, { useMemo } from 'react';

function formatTimestamp(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

function getActiveChapterIndex(chapters, currentTimeMs) {
  if (!chapters || chapters.length === 0) return -1;
  let active = 0;
  for (let i = 0; i < chapters.length; i++) {
    if (currentTimeMs >= (chapters[i].timestamp_ms || 0)) {
      active = i;
    }
  }
  return active;
}

export default function ChapterSidebar({ chapters, currentTimeMs, onSeek, isOpen, onToggle }) {
  const activeIndex = useMemo(
    () => getActiveChapterIndex(chapters, currentTimeMs),
    [chapters, currentTimeMs],
  );

  const toggleBtnStyle = {
    position: 'absolute',
    top: 8,
    left: 8,
    zIndex: 20,
    background: 'rgba(0,0,0,0.7)',
    color: '#f8fafc',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 6,
    width: 32,
    height: 32,
    fontSize: 18,
    lineHeight: '30px',
    textAlign: 'center',
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const panelStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    width: 220,
    zIndex: 15,
    background: 'rgba(10,10,20,0.92)',
    borderRight: '1px solid rgba(255,255,255,0.1)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backdropFilter: 'blur(4px)',
  };

  const headerStyle = {
    padding: '10px 12px 10px 48px',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#94a3b8',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    flexShrink: 0,
  };

  const listStyle = {
    flex: 1,
    overflowY: 'auto',
    padding: '6px 0',
  };

  return (
    <>
      <button
        onClick={onToggle}
        aria-label={isOpen ? 'Hide chapters' : 'Show chapters'}
        title={isOpen ? 'Hide chapters' : 'Show chapters'}
        style={toggleBtnStyle}
      >
        &#8801;
      </button>

      {isOpen && chapters && chapters.length > 0 && (
        <div style={panelStyle} role="navigation" aria-label="Video chapters">
          <div style={headerStyle}>Chapters</div>
          <div style={listStyle}>
            {chapters.map((chapter, i) => {
              const isActive = i === activeIndex;
              return (
                <button
                  key={i}
                  onClick={() => onSeek(chapter.timestamp_ms || 0)}
                  title={chapter.description || chapter.title}
                  style={{
                    display: 'block',
                    width: '100%',
                    textAlign: 'left',
                    background: isActive ? 'rgba(59,130,246,0.2)' : 'transparent',
                    border: 'none',
                    borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
                    borderRadius: 0,
                    padding: '8px 12px 8px 10px',
                    cursor: 'pointer',
                    color: isActive ? '#f8fafc' : '#94a3b8',
                    transition: 'background 0.15s, color 0.15s',
                  }}
                >
                  <div style={{ fontSize: 11, color: isActive ? '#60a5fa' : '#475569', marginBottom: 2 }}>
                    {formatTimestamp(chapter.timestamp_ms || 0)}
                  </div>
                  <div style={{
                    fontSize: 13,
                    fontWeight: isActive ? 600 : 400,
                    lineHeight: 1.3,
                    wordBreak: 'break-word',
                  }}>
                    {chapter.title || `Chapter ${i + 1}`}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
